import { GET_REQUESTACCESS_COLLECTION ,RESET_REQUESTACCESS_COLLECTION} from '../../constants/reducerTypes';

const initialState = { requestAccessLoader: true };
const requestAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REQUESTACCESS_COLLECTION:
      return {
        ...state,
        requestAccessCollection: action?.payload?.results ? [...action.payload.results] : [],
        requestAccessLoader: false,
      };
    case RESET_REQUESTACCESS_COLLECTION:
      return initialState;
    default:
      return state;
  }
};
export default requestAccessReducer;
